import { render, staticRenderFns } from "./VideoControl.vue?vue&type=template&id=00357f63&scoped=true&"
import script from "./VideoControl.vue?vue&type=script&lang=js&"
export * from "./VideoControl.vue?vue&type=script&lang=js&"
import style0 from "./VideoControl.vue?vue&type=style&index=0&id=00357f63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00357f63",
  null
  
)

export default component.exports